import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.css'
})
export class CookieBannerComponent implements OnInit {
  isVisible = false;

  ngOnInit(): void {
    this.isVisible = !this.hasConsent();
  }

  accept(): void {
    try {
      localStorage.setItem('cookieConsent', JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    } catch (e) {
      // localStorage non disponibile: il banner verrà riproposto alla prossima visita
    }
    this.isVisible = false;
  }

  private hasConsent(): boolean {
    try {
      return !!localStorage.getItem('cookieConsent');
    } catch (e) {
      return false;
    }
  }
}
